var sliders = document.querySelectorAll(".single-product__carousel");

var defaultOptions = {};

sliders.forEach(function (el) {
  var data = el.getAttribute("data-swiper") || {};
  var dataOptions = data ? JSON.parse(data) : {};

  el.options = Object.assign({}, defaultOptions, dataOptions);

  new Swiper(el, el.options);
});

jQuery(function ($) {
  if (!$(".three-tabs__tab-toggle").length) {
    return;
  }

  var selectedTab = getTabNameFromHref(
    $(".three-tabs__tab-toggle").first().attr("href")
  );

  if ($(".three-tabs__tab-toggle").length) {
    updateTabsState();

    $(".three-tabs__tab-toggle").on("click", function (e) {
      e.preventDefault();
      selectedTab = getTabNameFromHref($(this).attr("href"));
      updateTabsState();
      updateMobileTabsState($(this));
    });
  }

  function updateTabsState() {
    $(".three-tabs__tab-toggle").each(function () {
      if (getTabNameFromHref($(this).attr("href")) === selectedTab) {
        $(this).closest(".three-tabs__tab").addClass("active");
      } else {
        $(this).closest(".three-tabs__tab").removeClass("active");
      }
    });

    $(".three-tabs__tab-content").removeClass("active");
    $("." + selectedTab + "-content").addClass("active");
  }

  function updateMobileTabsState($toggle) {
    var $target = $(".three-tabs--mobile-only").find(
      "." + getTabNameFromHref($toggle.attr("href")) + "-content"
    );

    if ($target.hasClass("expanded")) {
      $target.css("height", $target.prop("scrollHeight"));
      setTimeout(function () {
        $target.css("height", 0);
      }, 0);
    } else {
      $target.css("height", $target.prop("scrollHeight"));
      if ($target.prop("scrollHeight") == 0) {
        $target.css("height", "auto");
      } else {
        $target.on("transitionend", function () {
          $target.css("height", "auto");
          $target.off("transitionend");
        });
      }
    }
    $target.toggleClass("expanded");
    $target.closest(".three-tabs__tab").toggleClass("expanded");
  }

  function getTabNameFromHref(href) {
    return href.substr(1);
  }
});
